import { StyleSheet } from 'react-native';
import { Colors } from '@shared/styles';

export const Styles = StyleSheet.create({
  header: {
    backgroundColor: Colors.gray.touch,
  },
  rightButtonPosition: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
  },
});
